/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Event_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Event notes" |
*
* @param {Notes_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_event_aria_label = /** @type {((inputs?: Notes_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsnotizen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note sull'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания к мероприятию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动笔记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントノート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना संबंधी नोट्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas do evento")
	return /** @type {LocalizedString} */ ("Event notes")
});